// Copyright (c) 2019 Deere & Company

import OktaState, { getDefaultState as getOktaStatesDefaultState } from './okta-state';
import t from 'tcomb';

const State = t.struct( {
    oktaState: OktaState
}, 'State' );

export const getDefaultState = () => new State( {
    oktaState: getOktaStatesDefaultState()
} );

export default State;
